<template>
  <button 
    class="copy-button" 
    :class="{ 'copied': copied }"
    @click="handleCopy"
    :title="copied ? 'Copied!' : 'Click to copy'"
  >
    <i v-if="!copied" class="bi bi-clipboard"></i>
    <i v-else class="bi bi-check2"></i>
  </button>
</template>

<script>
import { copyToClipboard } from '@/shared/workflowHistoryUtils';

export default {
  name: 'CopyButton',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      copied: false
    };
  },
  methods: {
    async handleCopy() {
      const success = await copyToClipboard(this.text);
      if (success) {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      }
    }
  }
};
</script>

<style scoped>
.copy-button {
  background: transparent;
  border: 1px solid var(--border-default);
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  color: #9ca3af;
}

.copy-button:hover {
  background-color: var(--form-bg);
  border-color: var(--border-hover);
  color: var(--text-primary);
}

.copy-button.copied {
  background-color: var(--form-bg);
  border-color: #10b981;
  color: #10b981;
}
</style>
